module.exports = __webpack_public_path__ + "static/media/praia_mar_fundo.ed6f1fc8.jpg";